<template>
  <div class="container">
    <div class="container" style="flex: 1;">
      <el-form :model="form" style="width: 80%;" ref="refForm" :rules="rules" label-width="180px">
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.selectCustomerInformation')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.customerName') + ':'" prop="customerId">
              <el-select
                v-model="form.customerId"
                clearable
                filterable
                style="width: 100%;"
                size="small"
                @change="changeCustomer">
                <el-option
                  v-for="item in customersList"
                  :key="item.id"
                  :label="item.customerName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.contact') + ':'" prop="contact">
              <el-input
                v-model.trim="form.contact"
                name="contact"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="16">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.contactPhone') + ':'" prop="contactPhone">
              <el-input
                v-model.trim="form.contactPhone"
                name="contactPhone"
                type="tel"
                autocomplete="on"
                clearable
                size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.address') + ':'" prop="contactAddr">
              <el-input
                v-model.trim="form.contactAddr"
                name="contactAddr"
                type="text"
                autocomplete="on"
                clearable
                size="small"
                maxlength="64"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="20">
            <el-form-item :label="$t('common.comment') + ':'">
              <el-input
                v-model="form.comment"
                name="comment"
                type="textarea"
                autocomplete="on"
                clearable
                size="small"
                maxlength="200"
                show-word-limit
                rows="4">
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.chooseExpressDelivery')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.expressageType')" prop="expressageType">
              <el-select
                v-model="form.expressageType"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key) in expressageTypes"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('common.expressage')" prop="expressage">
              <el-select
                v-model="form.expressage"
                clearable
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, key)  in expressages"
                  :key="key"
                  :label="item.explain"
                  :value="item.val">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.chooseBinLevel')}}</h4>
        </el-form-item>
        <el-form-item label-width="0">
          <el-col :span="10">
            <el-form-item :label="$t('common.binLevel')" prop="binLevelArr">
              <el-select
                v-model="form.binLevelArr"
                clearable
                collapse-tags
                multiple
                filterable
                style="width: 100%;"
                size="small">
                <el-option
                  v-for="(item, index) in 8"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0;">
          <h4 style="color: #169BD5;">{{$t('deliveryGoods.confirmedQuantity')}}</h4>
        </el-form-item>
      </el-form>
      <div class="target-container">
        <el-table
          ref="table"
          height="100%"
          border
          :data="orders"
          :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
          :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
          header-cell-class-name="headerCellName"
          :row-key="getRowKeys"
          :span-method="objectSpanMethod">
          <el-table-column fixed prop="incoOrderNo" :label="$t('common.orderNo')"/>
          <el-table-column :label="$t('common.customerName')">
            <template slot-scope="scope">
              {{scope.row.customer && scope.row.customer.customerName}}
            </template>
          </el-table-column>
          <el-table-column prop="subNo" :label="$t('common.subNo')"/>
          <el-table-column :label="$t('common.productName')" width="200">
            <template slot-scope="scope">
              {{productName(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
          <el-table-column :label="$t('common.processType')" width="100">
            <template slot-scope="scope">
              {{processTypeVal(scope.row.processType)}}
            </template>
          </el-table-column>
          <el-table-column prop="count" :label="$t('common.count')" width="100"/>
          <el-table-column width="80" :label="$t('common.status')">
            <template slot-scope="scope">
              {{storeStatusVal(scope.row.status)}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.storePassCount')" width="100">
            <template slot-scope="scope">
              {{scope.row.passCount - scope.row.sendPassCount}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.storeFailCount')" width="100">
            <template slot-scope="scope">
              {{scope.row.failCount - scope.row.sendFailCount}}
            </template>
          </el-table-column>
          <el-table-column width="100" :label="$t('incomingOrder.sendCount')">
            <template slot-scope="scope">
              {{scope.row.sendFailCount + scope.row.sendPassCount}}
            </template>
          </el-table-column>
          <el-table-column v-for="(row, key) in 8" :label="$t('common.binLevel') + row" :key="key">
            <template slot-scope="scope">
              {{scope.row.inStoreCount && scope.row.inStoreCount['binlevel' + row]}}
            </template>
          </el-table-column>
          <el-table-column width="180" fixed="right" :label="$t('common.expectedDeliveryNumber')">
            <template slot-scope="scope">
              <el-input
                v-model.trim.number="scope.row.deliveryNumber"
                type="tel"
                autocomplete="on"
                clearable
                size="small"
                maxlength="10"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="control-container">
      <div>
        <el-button @click="prevStep" size="small" class="prev-button">
          {{$t('common.prevStep')}}
        </el-button>
        <el-button :loading="loading" @click="submitForm" size="small" class="sure-button">
          {{$t('deliveryGoods.sureBuild')}}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { prodOrderPost } from '@/api/prodOrder';
import { customersList } from '@/api/customers';
import {
  validateContactPhone,
} from '@/utils/validate';
import {
  priorityLevels, processTypes, storeStatus, expressages, expressageTypes,
} from '@/utils/defines';
import { isValueEmpty, isPositiveIntegerNum } from '@/utils';

const defaultForm = {
  customerId: undefined,
  contact: undefined,
  contactPhone: undefined,
  contactAddr: undefined,
  comment: undefined,
  expressageType: expressageTypes.express.val,
  expressage: expressages.SF.val,
  priorityLevel: priorityLevels.low.val,
  binLevelArr: [],
};

export default {
  name: 'check-info',
  props: [
    'selectedOrders',
  ],
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.prodOderExplain || storeStatueItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      rules: {
        customerId: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.customerNameCanNotBeEmpty') }],
        contact: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        contactPhone: [{ required: true, trigger: 'blur', validator: validateContactPhone }],
        contactAddr: [{ required: true, trigger: 'blur', message: this.$t('incomingOrder.contactCanNotBeEmpty') }],
        expressageType: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageTypeCanNotBeEmpty') }],
        expressage: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.expressageCanNotBeEmpty') }],
        binLevelArr: [{ required: true, trigger: 'blur', message: this.$t('deliveryGoods.binLevelArrCanNotBeEmpty') }],
      },
      customersList: [],
      processTypesObj,
      storeStatusObj,
      expressages,
      expressageTypes,
      orders: [],
      loading: false,
    };
  },
  mounted() {
    this.customersListGet(1, 2000);
  },
  watch: {
    selectedOrders: {
      handler(newVal) {
        const order = [];
        for (let row of newVal) {
          order.push({...row});
        }
        this.orders = order;
      },
      immediate: true,
    },
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    prevStep() {
      this.$emit('prevStep');
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.sureBuild();
        }
      });
    },
    async sureBuild() {
      const {
        customerId,
        contact,
        contactPhone,
        contactAddr,
        comment,
        expressageType,
        expressage,
        priorityLevel,
        binLevelArr,
      } = this.form;
      const incoOrdersDetail = [];
      let count, productId, rowspan;
      let inStoreCount, inStoreCountSet = new Set();
      for (const row of this.orders) {
        count = row.deliveryNumber;
        rowspan = row.rowspan;
        inStoreCount = row.inStoreCount;
        if (rowspan && isValueEmpty(count)) {
          this.$message({
            type: 'error',
            message: this.$t('deliveryGoods.expectedDeliveryNumberCanNotBeEmpty'),
          });
          return false;
        }
        if (rowspan && !isPositiveIntegerNum(count)) {
          this.$message({
            type: 'error',
            message: this.$t('deliveryGoods.expectedDeliveryNumberMustMoreThan0'),
          });
          return false;
        }
        for (let i = 1; i <= 8; i++) {
          if (inStoreCount['binlevel' + i]) {
            inStoreCountSet.add(i);
          }
        }
        if (productId === undefined) {
          productId = row.productId;
        }
        if (row.rowspan) {
          incoOrdersDetail.push({
            count,
            incoOrderNo: row.incoOrderNo,
          });
        }　
      }
      let isInStoreNotHasBinLevel = false, notHasBinLevel = [];
      for (let row of binLevelArr) {
        if (!inStoreCountSet.has(row)) {
          isInStoreNotHasBinLevel = true;
          notHasBinLevel.push(row);
        }
      }
      if (isInStoreNotHasBinLevel) {
        this.$confirm('在库芯片中暂无档位' + notHasBinLevel.join('、') + '芯片，是否继续创建', this.$t('remindInfo.warning'), {
          confirmButtonText: this.$t('remindInfo.confirm'),
          cancelButtonText: this.$t('remindInfo.cancel'),
          type: 'warning',
        }).then(async () => {
          this.loading = true;
          try {
            await prodOrderPost({
              priorityLevel,
              customerId,
              contact,
              contactPhone,
              contactAddr,
              comment: comment || undefined,
              expressageType,
              expressage,
              incoOrdersDetail,
              binLevelArr,
            });
            this.$message({
              type: 'success',
              message: this.$t('deliveryGoods.buildSuccess'),
            });
            this.$emit('nexStep');
          } catch (e) {
            // do nothing.
          } finally {
            this.loading = false;
          }
        }).catch(() => {
          // do nothing.
        });
      } else {
        this.loading = true;
        try {
          await prodOrderPost({
            priorityLevel,
            customerId,
            contact,
            contactPhone,
            contactAddr,
            comment: comment || undefined,
            expressageType,
            expressage,
            incoOrdersDetail,
            binLevelArr,
          });
          this.$message({
            type: 'success',
            message: this.$t('deliveryGoods.buildSuccess'),
          });
          this.$emit('nexStep');
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      }
    },
    changeCustomer(val) {
      if (val) {
        for (const row of this.customersList) {
          if (row.id === val) {
            this.form.contact = row.contact;
            this.form.contactPhone = row.contactPhone;
            this.form.contactAddr = row.contactAddr;
            this.$refs.refForm.validateField(['customerId', 'contact', 'contactPhone', 'contactAddr']);
            break;
          }
        }
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
        if (this.customersList && this.customersList.length > 0) {
          const {
            id,
            contact,
            contactPhone,
            contactAddr,
          } = this.customersList[0];
          this.form.customerId = id;
          this.form.contact = contact;
          this.form.contactPhone = contactPhone;
          this.form.contactAddr = contactAddr;
        }
      } catch (e) {
        // do nothing.
      }
    },
    productName(row) {
      const { product } = row;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName}`;
    },
    processTypeVal(val) {
      return this.processTypesObj[val];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 7 || columnIndex === 19) {
        if (row.rowspan) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  .el-form {
    padding: 10px 20px 0;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .control-container {
    background: #F5F5F5;
    padding: 20px;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .target-container {
    margin: 20px 20px 0;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .prev-button {
    background: white;
    color: #EC7900;
    border: #EC7900 solid 1px;
  }
  .sure-button {
    background: #EC7900;
    color: white;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
